import { createFileRoute } from "@tanstack/react-router";
import { PipelineVersionPage } from "@client/components/doc-center/pipelines";

export const Route = createFileRoute("/_app/data-center/tmpl/versions/$id")({
  component: PipelineVersionRoute,
});

function PipelineVersionRoute() {
  const { id } = Route.useParams();
  return <PipelineVersionPage id={id} />;
}
